<template>
  <hr class="text-darkGray-400 my-1" />
</template>

<script setup></script>
